<template>
  <div class="product-box">
    <el-carousel height="42vw">
      <el-carousel-item v-for="(item, index) in pics" :key="item">
        <el-image :src="item" fit="fit" @click="handleClickBanner(index)"></el-image>
      </el-carousel-item>
    </el-carousel>
    <!-- 调整 gutter 值 改变产品卡片的间距 -->
    <el-row :gutter="24" class="product">
      <el-col :xs="24" :sm="12" :md="12" :lg="12" :xl="12" v-for="(item, index) in products" :key="index">
        <ProductBox :title="item.title" :desc="item.desc" :img="item.pic" :url="item.url" />
      </el-col>
    </el-row>
    <div class="partner">
      <div class="divider">
        <el-divider>合作伙伴</el-divider>
      </div>
      <el-image style="width: 100%; height: 100%" :src="partner" fit="fit"></el-image>
    </div>
  </div>
</template>

<script>
import ProductBox from '@/components/ProductBox'
export default {
  name: 'Home',

  mixins: [],

  components: {
    ProductBox,
  },

  props: {},

  data() {
    return {
      products: [
        {
          // title: 'RPLIDAR 360度激光扫描测距雷达',
          // desc: '全向激光扫描，用户可配置的扫描频率',
          pic: require('@/assets/images/product-x2.jpg'),
          url: '/product/x2',
        },
        {
          // title: 'RPLIDAR 360度激光扫描测距雷达',
          // desc: '全向激光扫描，用户可配置的扫描频率',
          pic: require('@/assets/images/product-y2.jpg'),
          url: '/product/y2',
        },
        {
          // title: 'RPLIDAR 360度激光扫描测距雷达',
          // desc: '全向激光扫描，用户可配置的扫描频率',
          pic: require('@/assets/images/product-p2.jpg'),
          url: '/product/p2',
        },
        {
          // title: 'RPLIDAR 360度激光扫描测距雷达',
          // desc: '全向激光扫描，用户可配置的扫描频率',
          pic: require('@/assets/images/product-ai.jpg'),
          url: '/product/ai',
        },
        {
          // title: 'RPLIDAR 360度激光扫描测距雷达',
          // desc: '全向激光扫描，用户可配置的扫描频率',
          pic: require('@/assets/images/product-system.jpg'),
          url: '/product/sys',
        },
        {
          // title: 'RPLIDAR 360度激光扫描测距雷达',
          // desc: '全向激光扫描，用户可配置的扫描频率',
          pic: require('@/assets/images/product-promote.jpg'),
          url: '/product/pro',
        },
      ],
      clientWidth: 0,
    }
  },

  computed: {
    partner() {
      let pic = ''
      if (this.clientWidth > 768) {
        pic = require('@/assets/images/partner.jpg')
      } else {
        pic = require('@/assets/images/m-partner.jpeg')
      }
      return pic
    },
    pics() {
      let arr = []
      if (this.clientWidth > 768) {
        arr = [
          require('@/assets/images/h-1.jpeg'),
          require('@/assets/images/h-2.jpg'),
          require('@/assets/images/h-3.jpg'),
        ]
      } else {
        arr = [
          require('@/assets/images/h-1m.jpg'),
          require('@/assets/images/h-2m.jpg'),
          require('@/assets/images/h-3m.jpg'),
        ]
      }
      return arr
    },
  },

  watch: {},

  created() {},

  mounted() {
    this.clientWidth = document.body.clientWidth
    window.onresize = () => {
      return (() => {
        this.clientWidth = document.body.clientWidth
      })()
    }
  },

  destroyed() {},

  methods: {
    handleClickBanner(index) {
      if (index == 0) {
        this.$router.push('/product/x2')
      } else if (index == 1) {
        this.$router.push('/product/y2')
      } else if (index == 2) {
        this.$router.push('/product/p2')
      }
    },
  },
}
</script>

<style lang="less" scoped>
.product-box,
.product-box * {
  border-radius: 0 !important; /* 去掉产品卡片及其子元素的圆角 */
}
@media screen and (max-width: 768px) {
  /deep/.el-carousel__container {
    height: 165vw !important;
  }
  .image {
    width: 100%;
    height: 100%;
  }
  .divider {
    .el-divider__text,
    .el-link {
      font-size: 16px !important;
    }
  }
  .el-row {
    padding: 30px 12px 0px 12px;
  }
}

.el-carousel__item {
  cursor: pointer;
}

.product {
  box-sizing: border-box;
  width: 100vw;
  margin: 0 auto !important;
}

.partner {
  background: #fff !important;
  padding: 80px 40px;
  box-sizing: border-box;

  .divider {
    max-width: 50vw;
    margin: 0 auto;
    .el-divider__text,
    .el-link {
      white-space: nowrap;
      font-size: 22px;
      font-weight: 400;
    }
  }
}
@media screen and (min-width: 950px) {
  .product {
    .el-col {
      margin-bottom: 5px; /* 设置每个卡片之间的上下间距 */
    }
  }
  .product .el-col {
    flex: 0 0 50%; /* 一行显示2个产品 */
    max-width: 50%;
  }
  .el-row {
    padding: 60px 160px;
  }
}
</style>
